module.exports = __webpack_public_path__ + "img/legend_a.71ed2932.png";